import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Data, Router } from '@angular/router';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Project } from '@src/app/models/project';
import { FooterprojectlistService } from './service/footerprojectlist.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-footerprojectlist',
  templateUrl: './footerprojectlist.component.html',
  styleUrls: ['./footerprojectlist.component.css']
})
export class FooterprojectlistComponent implements OnInit {
  projectlist:Project[];
  @Output() openProject = new EventEmitter<string>(true);
  constructor(
    private auth:AuthorizationService,
    private fplsrv:FooterprojectlistService,
    private uieventhub:UieventhubService,
    private router:Router,
    private datastore:DatastoreService
    
  
    ) { }

  ngOnInit(): void {
    this.datastore.projectList$.pipe(untilDestroyed(this)).subscribe(plist =>{
      this.projectlist = plist.filter(p => p.isactive === true);
    });
  }
  navigate(proj:Project){
    this.uieventhub.setCurrentProject(proj.projectId);
    SessionHelper.setCurrentProject(proj.projectId);
    SessionHelper.setCurrentProjectName(proj.title);
    SessionHelper.setCurrentProjectFull(JSON.stringify(proj));
    this.openProject.emit(proj.projectId);
   if(JSON.parse(SessionHelper.getCustomer()).customerType === 'light') {
    // Light project view
    this.router.navigate(['/customerlight']);
    return;
   }

    this.router.navigate(['/portal/project/',proj.projectId]);
   
  }

}
